import api from '@pray/shared/utils/api';

export async function getOffer({ artistId = '', offerId = '' }) {
  if (!offerId) throw new Error('Offer ID is required');

  const params = {
    artist_id: artistId,
  };

  const url = `/web/studio/offers/${offerId}`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
